import BaseStore from '@/store/base-store'

const options = {}
export default new BaseStore('campaigns', options)



// WEBPACK FOOTER //
// ./src/store/modules/campaigns.store.js